<ion-card>
    <ion-card-content>
        <ion-textarea placeholder="Enter comments here..." [(ngModel)]="document.comment" debounce="500" autocapitalize></ion-textarea>
    </ion-card-content>

</ion-card>
